import { render, staticRenderFns } from "./CloseSessionComponent.vue?vue&type=template&id=f47db052&scoped=true&"
import script from "./CloseSessionComponent.vue?vue&type=script&lang=ts&"
export * from "./CloseSessionComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47db052",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {VFlex})
